var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66529 0.734315C4.97771 1.04673 4.97771 1.55327 4.66529 1.86569L2.03098 4.5L4.66529 7.13432C4.97771 7.44673 4.97771 7.95327 4.66529 8.26569C4.35288 8.5781 3.84634 8.5781 3.53392 8.26569L0.333924 5.06569C0.0215045 4.75327 0.0215045 4.24673 0.333924 3.93431L3.53392 0.734315C3.84634 0.421895 4.35288 0.421895 4.66529 0.734315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.73b1bb6b4030a97047d4ab9c88f19493.svg";
export { ForwardRef as ReactComponent };